// Func = limiting Scope for this file
if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


var lastScrollTop = 0;

const HEADER_LOGO = document.getElementById('jsLogo');

(function(){


// SWIPER JS -------------------------------------------------------------------------------------

	// Swiper default setting
	let defaulsettings = {loop: true,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: false};

	// start slider default
    let allSwipper =[];

	document.querySelectorAll('.swiper-js').forEach((element,i) => {

		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;

		element.setAttribute(`data-swiper-${i}`,"");

		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

        allSwipper[i] = swiper;

        //custom count
        if(swiper.passedParams.customcount){
            let countcontainerall = document.querySelectorAll(`${swiper.passedParams.customcount}`);
            countcontainerall.forEach((element) => {element.innerHTML = `${swiper.realIndex + 1}`});
            swiper.on('slideChange', () => {
                countcontainerall.forEach((element) =>{
                    element.innerHTML = `${swiper.realIndex + 1} `;
                });
            });
        }
	});

	//custom swiper controller
    allSwipper.forEach((swiper) => {
        const customControl = swiper.passedParams.customcontrol;
        if (customControl) {
            const targetIds = customControl.substr(1).split(" ");
            const targetSwipers = allSwipper.filter((s) => targetIds.includes(s.el.id));
            if (targetSwipers.length > 0) {
                swiper.controller.control = targetSwipers;
            }
        }
    });

	// burger menu funcionality ----------------------------------------------------------------

		const burgerMenu = document.querySelector(".js-burger-menu");
		const closeMenu = document.querySelector(".burger-close-js");
		const openMenu = document.querySelectorAll(".js-menu-buger");

		//Open Menu
		openMenu.forEach( cta => {
			cta.addEventListener('click', function (e) {
				e.preventDefault();
				burgerMenu.classList.add("open");
				document.body.classList.add("no-scroll");
			});
		});

		//Close Menu
		closeMenu.addEventListener('click', () => {
			burgerMenu.classList.remove("open");
			document.body.classList.remove("no-scroll");
		});

		//Menu Burger submenu Funcionality
	
		document.querySelectorAll('.burger-menu__nav > li > a').forEach(link => {
			link.addEventListener('click', e => {
				if (link.nextSibling.nextSibling != null) {
					document.querySelectorAll('.inner > ul > li').forEach(item => {
						if (link.parentNode !== item) item.classList.remove('submenu-show');
					});
					//remove this comment if you want show subnav for mobile
					e.preventDefault();
					link.parentNode.classList.toggle('submenu-show');
					document.querySelector("#mobile-nav-js").classList.toggle('submenu-show')
				}
			});
		});

		//add class for icon dropdown 
		document.querySelectorAll('.burger-menu__nav > li > .sub-sub-menu').forEach(link => {
			let menu = link.parentNode.firstElementChild;
			menu.classList.toggle('ico-dropdown');
		})

		/* Subnav on mobile */
		let submenuHold = document.querySelectorAll('.sub-menu__hold');
		let allsublinks = document.querySelectorAll('.sub-menu a');
		if(allsublinks.length > 1){
			allsublinks.forEach(ele=>{
				ele.addEventListener('click', function(ev){
					if(ele.classList.contains('active')){
						ev.preventDefault();
					}
				});
			});
			let toggleBtn = document.querySelector('.sub-menu__toggle');
			if(toggleBtn){
				toggleBtn.addEventListener('click', function(){
					toggleBtn.parentElement.classList.toggle('open');
				});
			}
		}else if(submenuHold.length > 0){
			submenuHold[0].classList.add('hidden');
		}

		// Mobile Devices Click Emulator Button


		let burgerMenuMobile = document.querySelector('#burgerMenu');
		let openMenuBtn = document.querySelector(".js-menu-buger");

		if(burgerMenuMobile){
			burgerMenuMobile.addEventListener('click', () => {
				openMenuBtn.click();
			})
		}


	// MENU TABS ----------------------------------------------------------

	// function filterTabs(linksSelector, contentsSelector) {
	// 	let links = document.querySelectorAll(linksSelector);
	// 	let contents = document.querySelectorAll(contentsSelector);
	// 	if (links.length !== 0 && contents.length !== 0) {
	// 	  links[0].classList.add('active');
	// 	  contents[0].classList.add('active');
	// 	}
	  
	// 	links.forEach((link) => {
	// 	  link.addEventListener('click', () => {
	// 		links.forEach((allLinks) => {
	// 		  allLinks.classList.remove('active');
	// 		});
	// 		link.classList.add('active');
	// 		contents.forEach((content) => {
	// 		  let contentTag = content.getAttribute('data-tag');
	// 		  let linkTag = link.getAttribute('data-tag');
	// 		  content.classList.remove('active');
	// 			if (linkTag === contentTag) {
	// 				content.classList.add('active');
	// 			}
	// 		});
	// 	  });
	// 	});
	//   }
	  
	// filterTabs('.js-menu-tab', '.js-menu-content');

	// SELECT MOBILE

	// function filterSelect(selectSelector, selectSelectorOption,contentsSelector) {
	// 	let select = document.querySelector(selectSelector);
	// 	let links = document.querySelectorAll(selectSelectorOption)
	// 	let contents = document.querySelectorAll(contentsSelector);
	// 	if (links.length !== 0 && contents.length !== 0) {
	// 		links[0].classList.add('active');
	// 		contents[0].classList.add('active');
	// 	}
	// 	if (select && contents.length !== 0) {
	// 	  select.addEventListener('change', () => {
	// 		let selectedValue = select.value;
	// 		contents.forEach((content) => {
	// 		  let contentTag = content.getAttribute('data-tag');
	// 		  if (contentTag === selectedValue) {
	// 			content.classList.add('active');
	// 		  } else {
	// 			content.classList.remove('active');
	// 		  }
	// 		});
	// 	  });
	// 	}
	//   }
	  
	//   filterSelect('.js-menu-select','.js-menu-select option', '.js-menu-content');

	
	// LIST TABS ----------------------------------------------------------
	
	// let link_filter = document.querySelectorAll(".js-filter");
	// let all_item = document.querySelectorAll(".list-block__unit");

	// if (link_filter) {
	// 	link_filter.forEach(link => {
	// 		link.addEventListener('click', function(e) {
	// 			e.preventDefault();

	// 			link_filter.forEach(item => item.classList.remove("active"));
	// 			this.classList.add("active");

	// 			const filter_tag = this.dataset.filter;

	// 			all_item.forEach(currentItem => {
	// 				currentItem.classList.toggle("hidden", !currentItem.classList.contains(filter_tag));
	// 			});
	// 		});
	// 	});
	// }

	// Main Site Language ----------------------------------------------------------------

	// if(document.getElementById('language')){
	// 	document.getElementById('language').addEventListener("change", function(e){
			
	// 		changeLanguage(e.target.value);
	// 	});
	// }

	// CONVERT BUTTON  ----------------------------------------------------------------


	function convertBtn(classList, excludeElementSelector) {
		if (classList.length > 0) {
		classList.forEach((className) => {
			let elements = document.querySelectorAll('.' + className);
			elements.forEach((btn) => {
			// Verificar si el elemento actual no coincide con el selector de exclusión
			if (!btn.matches(excludeElementSelector)) {
				let INNER_TEXT = btn.innerHTML;
				btn.innerHTML = '<span>' + INNER_TEXT + '</span> <div class="bell"></div>';
			}
			});
		});
		}
	}

	convertBtn(['book-now']);


	document.addEventListener("DOMContentLoaded", function(event) {
		window.onload = onLoad();
	});

	// Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//// Forms animation for labels   ----------------------------------------------------------------
	//Email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	//vanilla JS fancybox  ----------------------------------------------------------------

	
	// if(document.getElementsByClassName('lightbox').length > 0){
	// 	let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
	// 	let allLightboxesLength = allLightboxes.length;

	// 	for(let j = 0; j < allLightboxesLength; j++ ){
	// 		allLightboxes[j].addEventListener('click', function(e){
	// 			e.preventDefault();
	// 			let currentTarget = this.getAttribute('href').split('#')[1];
	// 			document.getElementById(currentTarget).classList.add('open')
	// 		});
	// 	}

	// 	let allLightcloses = document.getElementsByClassName('js-lightboxclose');
	// 	let allLightclosesLength = allLightcloses.length;

	// 	for(let j = 0; j < allLightclosesLength; j++ ){
	// 		allLightcloses[j].addEventListener('click', function(e){
	// 			e.preventDefault();
	// 			let currentTarget = this.parentElement.parentElement.id;
	// 			document.getElementById(currentTarget).classList.remove('open')
	// 		});
	// 	}
	// }

	// Main Nav Dropdown ----------------------------------------------------------------
	const navItems = document.querySelectorAll('#primary-nav li');
	if(navItems){
		navItems.forEach(function (item) {
			item.addEventListener('mouseover', function () {
				item.classList.add('hover');
				let submenu = item.querySelector('ul.submenu');
				if (submenu) {
					submenu.classList.add('open');
				}
			});
	
			item.addEventListener('mouseout', function () {
				item.classList.remove('hover');
				let submenu = item.querySelector('ul.submenu');
				if (submenu) {
					submenu.classList.remove('open');
				}
			});
		});
	}
	
	// Booking extra functionality ----------------------------------------------------------------

	let bookingOpen = document.querySelector('.bookingCMS');
	let headerBookingClass = document.querySelector('.header');
	let closeBookingClass = document.querySelector('.closeBooking');


	bookingOpen.addEventListener('click', function(){
		headerBookingClass.classList.toggle('bookingOpened');
	});

	closeBookingClass.addEventListener('click', function(){
		bookingOpen.click();
	});

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			// let altLogo = HEADER_LOGO.dataset.alt;
			// let sourceLogo = HEADER_LOGO.getAttribute('src');
			// changeLogo(altLogo,sourceLogo)
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			// let altLogo = HEADER_LOGO.dataset.alt;
			// let sourceLogo = HEADER_LOGO.getAttribute('src');
			// changeLogo(altLogo,sourceLogo)
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

// function changeLogo(src,alt) {
// 	HEADER_LOGO.setAttribute('src',src);
// 	HEADER_LOGO.setAttribute('data-alt',alt);
// }

function onLoad(){

	//Check anchor on URL
	let anchorHref = window.location.href;
	if(anchorHref.indexOf('#') > 0){
		if(anchorHref.split('#').length === 2){
			let windowTarget = anchorHref.split('#')[1];
			if(document.getElementById(windowTarget)){
				setTimeout(() => {
					animateTo(windowTarget);
				}, 600);
			}
		}
	}

	//Check anchor on buttons
	let btnAnchor = document.querySelectorAll('.btn');
	btnAnchor.forEach(btn => {
		btn.addEventListener('click', () =>{
			let hrefValue = btn.getAttribute('href');
			console.log(hrefValue);
			if(hrefValue.indexOf('#') > 0){
				if(hrefValue.split('#').length  === 2){
					let windowTarget = hrefValue.split('#')[1];
						if(document.getElementById(windowTarget)){
							setTimeout(() => {
								animateTo(windowTarget).scrollBy(0, -170);
							}, 600);
						}
				}
			}
		});
	});

	if((!document.getElementById('gallery') && !document.getElementById('attractions')) && (document.getElementsByClassName('no-hero').length < 1)){
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	} else {
		document.getElementById('header').classList.add('scroll');
		let altLogo = HEADER_LOGO.dataset.alt;
		let sourceLogo = HEADER_LOGO.getAttribute('src');
		changeLogo(altLogo,sourceLogo)
	}

	/* Lightbox Gallerys */
	const customLightbox = new LBX('.js-lbx-gallery', {
		customClass:'lbx-gallery',
	});
	
}



//vanilla js scroll TO animation ----------------------------------------------------------------
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 250;
	var from = window.pageYOffset;
	var to = gotoTarget;
	var duration = 1300;
	var start = new Date().getTime();

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start;

		if (from <= to) {
			var y = easeInOutQuart(time, from, to - from, duration);
		} else {
			var y = easeInOutQuart(time, from, -(from - to), duration);
		}
		window.scrollTo(0, y);
		if (time >= duration) clearInterval(timer);
	}, 1000 / 60);

	window.scrollTo(0, from);
}
// Ease movement ----------------------------------------------------------------
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}




